export default "__VITE_ASSET__BoCb1RfN__"